
import { PUBLIC_PAGE_API_ENDPOINT } from "../constants"

export const getAllItems = async (path: string) => {
    // if (!query) return

    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Accept-Language": "sv",
    }

    const options: RequestInit = {
        headers: headers,
        mode: "cors",
        credentials: "include",
    }

    return await fetch(
        `${PUBLIC_PAGE_API_ENDPOINT}/api/${path}?skip=0&take=1000`,
        options
    ).then((r) => {
        return r.json()
    })
}
export const getAllUnits = async (
    predefinedCareTypeIds: string,
    predefinedDiagnoseIds: string,
    diagnoseIds: string,
    diagnoseIdsSecondLevel: string,
    careTypeIds: string,
    regionIds: string,
    blockId: number,
    lon: string,
    lat: string) => {
    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Accept-Language": "sv",
    }

    const options: RequestInit = {
        headers: headers,
        mode: "cors",
        credentials: "include",
    }

    return await fetch(
        `${PUBLIC_PAGE_API_ENDPOINT}/api/units?skip=0&take=1000${diagnoseIds && '&diagnoseIds=' + diagnoseIds}${diagnoseIdsSecondLevel && '&diagnoseIdsSecondLevel=' + diagnoseIdsSecondLevel}${careTypeIds && '&careTypeIds=' + careTypeIds}${regionIds && '&regionIds=' + regionIds}${blockId ? '&blockId=' + blockId : ''}${lon && '&lon=' + lon}${lon && '&lat=' + lat}${predefinedCareTypeIds ? '&predefinedCareTypeIds=' + predefinedCareTypeIds : ''}${predefinedDiagnoseIds ? '&predefinedDiagnoseIds=' + predefinedDiagnoseIds : ''}`,
        options
    ).then((r) => {
        return r.json()
    })
}

export const getAllArticles = async (pageId: string) => {

    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Accept-Language": "sv",
    }

    const options: RequestInit = {
        headers: headers,
        mode: "cors",
        credentials: "include",
    }

    return await fetch(
        `${PUBLIC_PAGE_API_ENDPOINT}/api/contenthub/articles?skip=0&take=100&pageId=${pageId}`,
        options
    ).then((r) => {
        return r.json()
    })
}

